import React from "react";

const ProgramCard = ({ schools }) => {
  return (
    <div className="program-card-section">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {schools.map((school, index) => (
          <a
            key={index}
            href={school.website}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white p-6 rounded-lg shadow-md flex flex-col items-center text-center"
          >
            <h3 className="text-2xl font-semibold text-gray-800 mb-2">
              {school.school}
            </h3>
            <p className="text-gray-600 text-lg">{school.department}</p>
          </a>
        ))}
      </div>
    </div>
  );
};

export default ProgramCard;
